import script from "./PlayerWayOut.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerWayOut.vue?vue&type=script&setup=true&lang=js"

import "./PlayerWayOut.vue?vue&type=style&index=0&id=9f546896&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f546896"]])

export default __exports__